import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD0kjUz7Oje_QQrYyJRsRJdtq8IN4_-11s",
  authDomain: "twitter-clone01-c0afc.firebaseapp.com",
  projectId: "twitter-clone01-c0afc",
  storageBucket: "twitter-clone01-c0afc.appspot.com",
  messagingSenderId: "74472496275",
  appId: "1:74472496275:web:c2f5b865a5d0c7bd164166",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
